// extracted by mini-css-extract-plugin
export default {"wrapper":"g9elh"};